<template>
  <div class="content-wrapper">
    <PageHeader screen-name="Carteira de Vacinação" :linkItems="linkItems" />

    <div class="card pt-2">
      <main>
        <section class="filters pb-1" v-if="!loadingData">
          <filters
            @actionSearch="handleSearch"
            @actionClear="clearFilters"
            :disableButtonSearch="!canSearch"
            :disableButtonClear="disableClearButton"
          >
            <validation-observer ref="formFilters">
              <b-form>
                <b-row class="align-items-center px-2 pt-1">
                  <b-col sm="6" lg="6">
                    <b-form-group
                      label="Nome do colaborador"
                      label-for="name"
                      label-class="font_size_label"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Nome"
                      >
                        <b-form-input
                          id="name"
                          v-model="search.nome"
                          placeholder="Nome do colaborador"
                          autocomplete="off"
                          maxLength="255"
                          @input="validateSearch"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" lg="6">
                    <b-form-group
                      label="CPF"
                      label-for="cpf"
                      label-class="font_size_label"
                    >
                      <validation-provider #default="{ errors }" name="cpf">
                        <b-form-input
                          id="cpf"
                          v-model="search.cpf"
                          placeholder="000.000.000-00"
                          v-mask="'###.###.###-##'"
                          maxLength="14"
                          autocomplete="off"
                          @input="validateSearch"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </filters>
        </section>

        <div v-if="loadingData" class="d-flex justify-content-center my-3">
          <div class="spinner-border text-custom-blue">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <CarteiraVacinacaoTable
          v-if="!loadingData && showTable"
          table-id="tableCarteira"
          :filtering="filtering"
          :table="table"
          :pagination-data="paginationData"
          :without-results="withoutResults"
          :loading-vaccination-card="loadingVaccinationCard"
          @view-card="viewVaccinationCard"
          @generate-card="generateVaccinationCard"
          @generate-code="openModalGerarCodigo"
          @page-changed="updateCurrentPage"
          @update-qty="updateQtdView"
        />
      </main>
    </div>

    <CarteiraVacinacaoModal
      modal-id="modal-view-carteira"
      title="Carteira de Vacinação"
      :show.sync="showModalView"
      :loading-modal="loadingModal"
      :loading-download="loadingDownload"
      :html-content="htmlContent"
      @download="downloadVaccinationCard"
      @hidden="htmlContent = null"
    />

    <GerarCodigoAcessoModal
        :showModal="modalGerarCodigo.showModal"
        :colaborador="modalGerarCodigo.colaborador"
        @canceled="closeModalGerarCodigo(false)"
        @closed="closeModalGerarCodigo"
    />
  </div>
</template>

<script>
import {
  BForm,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  VBTooltip,
  BSpinner,
  BModal,
  BButton,
} from "bootstrap-vue";
import vSelect from 'vue-select'
import PageHeader from "@/views/components/custom/page-header/PageHeader.vue";
import Filters from '@/views/components/custom/filters/Filters.vue';
import CarteiraVacinacaoTable from '@/views/custom-pages/Vacinacao/components/CarteiraVacinacaoTable.vue';
import CarteiraVacinacaoModal from '@/views/custom-pages/Vacinacao/components/CarteiraVacinacaoModal.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { getUserData } from '@/auth/utils';
import chavePerfil from '@/enum/chavePerfil';
import GerarCodigoAcessoModal from "@/views/components/custom/modals/colaborador/GerarCodigoAcessoModal.vue";

export default {
  title: "Carteira de Vacinação",
  components: {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    PageHeader,
    ValidationObserver,
    ValidationProvider,
    Filters,
    BSpinner,
    BModal,
    BButton,
    vSelect,
    GerarCodigoAcessoModal,
    CarteiraVacinacaoTable,
    CarteiraVacinacaoModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      linkItems: [
        {
          name: "Registro de Vacinados",
          routeName: "vacinacao-list",
        },
        {
          name: "Carteira de Vacinação",
          active: true,
        },
      ],
      search: {
        nome: '',
        cpf: '',
      },
      filtering: false,
      loadingData: true,
      withoutResults: false,
      canSearch: false,
      showTable: false,
      table: {
        fields: [
          {key: "colaborador", label: "COLABORADOR", sortable: false, class: "mw-300"},
          {key: "cpf", label: "CPF", sortable: false, class: "mw-150"},
          {key: "situacao_codigo_acesso", label: "STATUS DE ACESSO", sortable: false, class: "mw-150"},
          {
            key: "acoes",
            label: "AÇÕES",
            sortable: false,
            class: "mw-150 text-center col-1",
          },
        ],
        items: [],
        optionsSize: [10, 25, 50, 100],
      },
      paginationData: {
        currentPage: 1,
        totalLines: 0,
        fromLine: 0,
        toLine: 0,
        defaultSize: 10,
      },
      loadingVaccinationCard: {},
      showModalView: false,
      loadingModal: false,
      loadingDownload: false,
      htmlContent: null,
      currentColaborador: null,
      modalGerarCodigo: {
        showModal: false,
        colaborador: {
          id_pessoa_fisica: null,
          nome: '',
          cpf: '',
        },
      },
    };
  },
  watch: {
    showModalView(newVal) {
      if (!newVal) {
        this.htmlContent = null;
      }
    },
  },
  computed: {
    disableClearButton() {
      return !this.search.nome && !this.search.cpf;
    },
    isAdminEmpresa() {
      const userData = getUserData();
      if (!userData || !userData.perfis || !userData.perfis.length) {
        return false;
      }
      return userData.perfis.some(perfil => perfil.chave === chavePerfil.ADMIN_EMPRESA);
    },
  },
  mounted() {
    if (!this.isAdminEmpresa) {
      this.$router.push({name: 'home'});
      this.$toast.error('Acesso negado. Esta funcionalidade é exclusiva para Admin Empresa.');
      return;
    }
    this.loadingData = false;
  },
  methods: {
    validateSearch() {
      const nomeRegex = /^[A-Za-zÀ-ú\s]+$/;
      const nomeValido = this.search.nome.trim().length >= 3 &&
          (this.search.nome.trim() === '' || nomeRegex.test(this.search.nome.trim()));

      const cpfNumerico = this.search.cpf.replace(/\D/g, '');
      const cpfValido = cpfNumerico.length >= 3;

      this.canSearch = nomeValido || cpfValido;
    },
    handleSearch() {
      if (!this.canSearch) {
        return;
      }
      this.table.items = [];
      this.withoutResults = false;
      this.showTable = true;
      this.filtering = true;
      this.paginationData.currentPage = 1;
      this.loadData();
    },
    clearFilters() {
      this.search.nome = '';
      this.search.cpf = '';
      this.canSearch = false;
      this.showTable = false;
      this.table.items = [];
      this.withoutResults = false;
      this.paginationData = {
        currentPage: 1,
        totalLines: 0,
        fromLine: 0,
        toLine: 0,
        defaultSize: 10,
      };
    },
    loadData() {
      this.table.items = [];
      this.withoutResults = false;

      const params = {
        tamanho: this.paginationData.defaultSize,
        pagina: this.paginationData.currentPage,
      };

      if (this.search.nome && this.search.nome.trim()) {
        params.nome = this.search.nome.trim().toLowerCase();
      }

      if (this.search.cpf) {
        const cpfNumerico = this.search.cpf.replace(/\D/g, '');
        if (cpfNumerico) {
          params.cpf = cpfNumerico;
        }
      }

      this.$http.get(this.$api.getColaboradoresCarteiraVacinacao(), {params})
          .then(({data}) => {
            this.table.items = data.data.map(item => ({
              ...item,
              possui_vacinacao: item.possui_vacinacao === undefined ? true : item.possui_vacinacao,
            }));

            this.withoutResults = data.data.length === 0;
            this.filtering = false;
            this.startPagination(data);
          })
          .catch((_error) => {
            const status = _error?.response?.status;

            if (status === 400) {
              console.error('CPF inválido.');
            }

            this.filtering = false;
            this.withoutResults = true;
            this.table.items = [];
          });
    },
    startPagination(data) {
      this.paginationData.currentPage = data.current_page;
      this.paginationData.totalLines = data.total;
      this.paginationData.fromLine = data.from;
      this.paginationData.toLine = data.to;
    },
    updateCurrentPage(page) {
      this.paginationData.currentPage = page;
      this.loadData();
    },
    updateQtdView() {
      this.paginationData.currentPage = 1;
      this.loadData();
    },
    viewVaccinationCard(colaborador) {
      this.currentColaborador = colaborador;
      this.showModalView = true;
      this.loadingModal = true;
      this.loadingDownload = false;
      this.htmlContent = null;

      const cpf = colaborador.cpf.replace(/\D/g, '');
      this.$http.get(this.$api.getVaccinationCardHtmlByCpf(cpf))
          .then(({data}) => {
            this.htmlContent = typeof data === 'string' ? data : (data.html || data.data || data);
            this.loadingModal = false;
          })
          .catch(() => {
            this.$toast.error("Erro ao carregar a carteira de vacinação, contate o suporte...");
            this.loadingModal = false;
            this.showModalView = false;
          });
    },
    downloadVaccinationCard() {
      if (!this.currentColaborador || !this.htmlContent) {
        return;
      }

      const cpf = this.currentColaborador.cpf.replace(/\D/g, '');
      this.loadingDownload = true;
      this.$toast.success('Gerando Carteira de Vacinação...');

      this.$http.get(this.$api.getVaccinationCardByCpf(cpf), {responseType: 'blob'})
          .then(({data}) => {
            const blob = new Blob([data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `carteira_de_vacinacao_${cpf}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
            this.$toast.success('Carteira de vacinação gerada com sucesso!');
          })
          .catch(() => {
            this.$toast.error('Erro ao gerar o PDF, tente novamente...');
          })
          .finally(() => {
            this.loadingDownload = false;
          });
    },
    generateVaccinationCard(cpf) {
      const cpfNumerico = cpf.replace(/\D/g, '');
      this.$set(this.loadingVaccinationCard, cpf, true);
      this.$toast.success('Gerando Carteira de Vacinação...');

      this.$http.get(this.$api.getVaccinationCardByCpf(cpfNumerico), {responseType: 'blob'})
          .then(({data}) => {
            const blob = new Blob([data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `carteira_de_vacinacao_${cpfNumerico}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
            this.$toast.success('Carteira de vacinação gerada com sucesso!');
          })
          .catch(() => {
            this.$toast.error("Erro ao gerar a carteira de vacinação, contate o suporte...");
          })
          .finally(() => {
            this.$set(this.loadingVaccinationCard, cpf, false);
          });
    },
    async openModalGerarCodigo(colaborador) {
      let idPessoaFisica = colaborador.id_pessoa_fisica;

      if (!idPessoaFisica && colaborador.cpf) {
        try {
          const cpfNumerico = colaborador.cpf.replace(/\D/g, '');
          const response = await this.$http.get(this.$api.getPessoaFisicaPorCpf(cpfNumerico));
          if (response.data && response.data.id_pessoa_fisica) {
            idPessoaFisica = response.data.id_pessoa_fisica;
          }
        } catch (error) {
          console.error('Erro ao buscar pessoa física:', error);
          this.$toast.error('Erro ao buscar dados do colaborador');
          return;
        }
      }

      if (!idPessoaFisica) {
        console.error('ID pessoa física não encontrado');
        this.$toast.error('Não foi possível identificar o colaborador');
        return;
      }

      this.modalGerarCodigo.showModal = true;
      this.modalGerarCodigo.colaborador = {
        id_pessoa_fisica: idPessoaFisica,
        nome: colaborador.nome,
        cpf: colaborador.cpf,
      };
    },
    closeModalGerarCodigo(codigoFoiGerado = false) {
      this.modalGerarCodigo.showModal = false;
      this.modalGerarCodigo.colaborador = {
        id_pessoa_fisica: null,
        nome: '',
        cpf: '',
      };

      if (codigoFoiGerado) {
        this.loadData();
      }
    },
  }
}
</script>

<style scoped>
.font_size_label {
  font-size: 15px;
  margin-top: -5px;
}

.comprimento_maximo_celulas {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}

.button-icon {
  background: none;
  border: none;
  padding: 0;
  align-items: center;
  cursor: pointer;
}

.button-icon:focus {
  outline: none;
}

.button-icon.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-wrapper {
  display: inline-block;
}

.html-container {
  height: 70vh;
  overflow: auto;
}
</style>
